import { AnyAction } from 'redux';
import { IAppState } from '../types/state.d';
import { httpActionTypes } from '../actions/actionCreators/actionTypes';

export default function http(
  state: IAppState['http'] = {},
  action: AnyAction,
): IAppState['http'] {
  switch (action.type) {
    case httpActionTypes.REQUEST_MADE:
      return {
        ...state,
        [action.request]: {
          isInFlight: true,
          isError: false,
          isSuccess: false,
        },
      };
    case httpActionTypes.REQUEST_SUCCESS:
      return {
        ...state,
        [action.request]: {
          isInFlight: false,
          isError: false,
          isSuccess: true,
        },
      };
    case httpActionTypes.REQUEST_ERROR:
      return {
        ...state,
        [action.request]: {
          isInFlight: false,
          isError: action.error,
          isSuccess: false,
        },
      };
    case httpActionTypes.REQUEST_RESET: {
      return Object.keys(state).reduce(
        (newState, currentRequest) => ({
          ...newState,
          [currentRequest]: {
            ...state[currentRequest],
            isError: false,
            isSuccess: false,
          },
        }),
        {},
      );
    }
    default:
      return state;
  }
}
